"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class LicenseController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/license/current',
            getChallenge: '/v1/license/challenge',
            setLicense: 'v1/license',
        };
    }
    list() {
        throw new Error("Can't list license");
    }
    count() {
        throw new Error("Can't count license");
    }
    create({}) {
        throw new Error("Can't create license!");
    }
    edit({}) {
        throw new Error("Can't edit license!");
    }
    delete() {
        throw new Error("Can't delete license!");
    }
    getChallenge() {
        return this.manager.get({
            url: this.endpoints.getChallenge,
        });
    }
    setLicense(license) {
        return this.manager.post({
            url: this.endpoints.setLicense,
        }, { license });
    }
}
exports.default = LicenseController;
